import { useSliceConnections } from "./use-slice-connections";
export var useLayoutRenderCheck = function (entity) {
  var _a = entity.entityViews,
    entityViews = _a === void 0 ? [] : _a;
  var asideViews = (entityViews === null || entityViews === void 0 ? void 0 : entityViews.filter(function (view) {
    var _a;
    return ((_a = view.type) === null || _a === void 0 ? void 0 : _a.slug) === 'aside';
  })) || [];
  var hasAsideViews = !!asideViews && asideViews.length > 0;
  var hasRenderableSlice = asideViews.some(function (view) {
    return view.slices.some(function (slice) {
      var shouldRender = useSliceConnections(slice).shouldRender;
      return shouldRender;
    });
  });
  // Not sure if required..?
  var items = [];
  if (hasAsideViews) {
    items = asideViews.flatMap(function (view) {
      return view.slices;
    });
  }
  ;
  return {
    entity: entity,
    shouldRender: hasRenderableSlice // Top-level rendering depends on any slice being renderable
  };
};